<template lang="pug">
.timeline-container.container
  .row.timeline-row
    template(
      v-for="row in 12"
      :key="`segment-${row}`"
    )
      .col-xs-1.p-0(
        :class="segment(row)"
      )
  .row.form-group
    template(
      v-for="(label, index) in labels"
      :key="`${label}-${index}`"
    )
      .text-center(
        :class="labelClass(index)"
      )
        span {{ label }}
</template>
<script>
export default {
  name: 'WorkBreakPolicyTimelineGraph',
  props: {
    rule: {
      type: Number,
      required: true,
    },
    minimum: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    unavailable() {
      if (!this.minimum) {
        return 0;
      }

      return this.rule === 3 ? 5 : 1;
    },
    separators() {
      if (this.rule === 2 || this.rule === 3) {
        return [4, 8];
      }

      return [];
    },
    labels() {
      const all = ['1st break available', '2nd break available', '3rd break available'];

      if (this.rule === 1) {
        return [all[0]];
      }
      if (this.rule === 2) {
        return all;
      }
      if (this.rule === 3) {
        return ['', all[0], all[1]];
      }

      return [];
    },
  },
  methods: {
    segment(row) {
      const border = this.separators.includes(row) || this.unavailable === row ? 'bordered' : '';
      const color = row > this.unavailable ? ' allowed' : ' forbidden';

      return border + color;
    },
    labelClass(row) {
      // First rule stretches one label
      if (this.rule === 1) {
        return this.minimum ? 'col-xs-11 col-xs-offset-1' : 'col-xs-12';
      }
      // First visible row is moved in case of minimum set
      if (this.minimum && this.rule === row + 2) {
        return 'col-xs-3 col-xs-offset-1';
      }

      return 'col-xs-4';
    },
  },
};
</script>
